module.exports = __webpack_public_path__ + "static/media/tic-tac-toe.8c1fb594.png";